export default function ($scope, $stateParams, editUser, $state, toaster, userDetails, userRoles) {
    const userId = $stateParams.userId;
    const vm = this;

    vm.allRoles = userRoles.items;
    vm.roles = {};
    vm.rolesError = null;

    for (let count = 0; count < vm.allRoles.length; count++) {
        vm.roles[vm.allRoles[count].value] = false;
    }

    vm.form = null;
    vm.saveUser = save;
    vm.recordNotFetched = true;
    vm.errorsOccurred = false;
    vm.rolesChange = rolesChange;
    vm.selected = [];
    vm.disable = disable;

    userDetails(userId)
        .then(userData => {
            vm.userData = userData;

            const roles = userData.roles.map(value => value);

            for (let count = 0; count < vm.allRoles.length; count++) {
                const isInRole = roles.indexOf(vm.allRoles[count].roleToSave) > -1;
                vm.roles[vm.allRoles[count].value] = isInRole;
                if (vm.allRoles[count].roleToSave === roles[0]) {
                    rolesChange(vm.allRoles[count]);
                }
            }

            vm.recordNotFetched = false;
            vm.errorsOccurred = false;
        })
        .catch(() => {
            vm.recordNotFetched = true;
            vm.errorsOccurred = true;
        });

    function rolesChange(role) {
        const pos = vm.selected.indexOf(role);
        if (pos > -1) {
            vm.selected.splice(pos, 1);
        } else {
            vm.selected.push(role);
        }
    }

    function disable(role) {
        return vm.selected.length >= 1 && vm.selected.indexOf(role) === -1;
    }

    function save() {
        if (this.form.$invalid) {
            return;
        }

        vm.userData.roles = [];
        vm.rolesError = null;

        for (let countAllRoles = 0; countAllRoles < vm.allRoles.length; countAllRoles++) {
            if (vm.roles[vm.allRoles[countAllRoles].value]) {
                vm.userData.roles.push(vm.allRoles[countAllRoles].roleToSave);
            }
        }

        if (!vm.userData.roles.length) {
            vm.rolesError = {required: true};
            return;
        }

        editUser(userId, vm.userData)
            .then(() => {
                $state.go('users.list');
                toaster.pop('success', 'The user is successfully saved');
            })
            .catch(() => {
                toaster.pop('error', 'An error occured when saving the user');
            });
    }
}



// WEBPACK FOOTER //
// ./Client/app/admin/users/controllers/edit/editUserCtrl.js